module.exports = __webpack_public_path__ + "assets/GoldBeta.cc88ac699c9bd1ebab0ee8ae4411faf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldBeta.png
// module id = 757
// module chunks = 0